import { FC, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { getBus } from "../../../api/shuttleSetting.api";
import useAxios from "../../../hooks/useAxios";
import { IGetBus, IBusDetail } from "../../../models/shuttleSetting.model";
import { ShuttleContents } from "../../../pages/campus/shuttle";
import ErrorResponse from "../../ErrorResponse";
import Loader from "../../Loader";
import { Descriptions } from "antd";
import { getCommonCodeLabel } from '../../../lib/store';
import Button from '../../../components/Button';
import { useSelector } from "react-redux";
import { RootState } from "../../../store/rootReducer";
import { useHistory } from 'react-router-dom';
import useAuth from "../../../hooks/useAuth";

interface IProps {
  bus: IBusDetail | undefined;
  setBus: (bus: IBusDetail) => void;
  busCode: number | undefined;
}

const BusRead: FC<IProps> = ({
  bus, setBus, busCode
}) => {
  const { t } = useTranslation();
  const { writeAuthYn } = useAuth();
  const history = useHistory();
  const { currentCampus } = useSelector((state: RootState) => state.auth);
  const { data: res, isLoading, error, execute } = useAxios<IGetBus>();

  useEffect(() => {
    if (busCode) {
      execute(getBus(currentCampus, busCode));
    }
  }, [busCode]);

  useEffect(() => {
    if (res && !isLoading) {
      setBus(res.data);
    }
  }, [res, isLoading]);

  return (
    <>
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />

      <div>
        <div className="comm-table__area rowType">
          <div className="profile w-200">
            <div className="box-photo mx-auto">
              {
                bus?.carAttachFile
                  ? <img className="img-preview" src={bus.carAttachFile.fileLocation} alt="preview" />
                  : null
              }
            </div>
          </div>
          <Descriptions className="w-100" bordered size="small" column={3}>
            <Descriptions.Item label={t('campus.shuttle.column1')} span={2}>
              {bus?.busName}
            </Descriptions.Item>
            <Descriptions.Item label={t('campus.shuttle.column4')}>
              {getCommonCodeLabel('BU0001', bus?.busGbn || '', 'ko')}
            </Descriptions.Item>
            <Descriptions.Item label={t('campus.shuttle.column2')}>
              {bus?.driverName}
            </Descriptions.Item>
            <Descriptions.Item label={t('campus.shuttle.column5')}>
              {bus?.telephoneNo}
            </Descriptions.Item>
            <Descriptions.Item label={t('campus.shuttle.column3')}>
              {bus?.busNo}
            </Descriptions.Item>
            <Descriptions.Item label={t('campus.shuttle.column6')}>
              {bus?.busType}
            </Descriptions.Item>
            <Descriptions.Item label={t('campus.shuttle.column7')}>
              {bus?.quota}
            </Descriptions.Item>
            <Descriptions.Item label={t("campus.shuttle.column8")}>
              {bus?.useYn}
            </Descriptions.Item>
            <Descriptions.Item label={t('campus.shuttle.column9')}>
              {
                bus?.contractFile
                  ? (
                    <a
                      className="download-link btn-text"
                      href={`${bus?.contractFile.fileLocation}`}
                      download={bus?.contractFile.originalName}
                    >
                      {bus?.contractFile.originalName}
                    </a>
                  )
                  : null
              }
            </Descriptions.Item>
            <Descriptions.Item label={t('campus.shuttle.column10')}>
              {bus?.salaryAmt}
            </Descriptions.Item>
            <Descriptions.Item label={t('campus.shuttle.column11')}>
              {bus?.depositor}
            </Descriptions.Item>
            <Descriptions.Item label={t('campus.shuttle.column12')}>
              {getCommonCodeLabel('SY0007', bus?.bankCode || '', 'ko')}
            </Descriptions.Item>
            <Descriptions.Item label={t('campus.shuttle.column13')} span={2}>
              {bus?.accountNo}
            </Descriptions.Item>
            <Descriptions.Item label={t('campus.shuttle.column14')} span={3}>
              {bus?.busNote}
            </Descriptions.Item>
          </Descriptions>
        </div>
      </div>

      <div className="comm-bx__between">
        <div className="comm-btn__area ">
          <Button
            className="btn-basic gray-line"
            onClick={() => history.push(`/campus/shuttle?index=${ShuttleContents.BusList}`)}
            text={t('common.button.list')}
          />
        </div>
        <div className="comm-btn__area  right">
          <Button
            className="btn-basic pink-line"
            onClick={() => history.push(`/campus/shuttle?index=${ShuttleContents.BusUpdate}`)}
            text={t('common.button.edit')}
            writeAuthYn={writeAuthYn}
          />
        </div>
      </div>
    </>
  );
}

export default BusRead;
